import BaseService from '@/services/BaseService'

class GrupoPermissaoService extends BaseService {
    constructor(){
        super('/v1/grupos-permissoes')
    }
}

export default new GrupoPermissaoService